import React from 'react';
import { useNavigate } from 'react-router-dom';
import GamePrice from './GamePrice';

function GameCard({ game, hidePrice = false, isOwned = false }) {
  const navigate = useNavigate();

  const handleClick = () => {
    // Scroll to top before navigation for mobile compatibility
    window.scrollTo(0, 0);
    if (document.documentElement) document.documentElement.scrollTop = 0;
    if (document.body) document.body.scrollTop = 0;
    navigate(`/game/${game.id}`);
  };

  return (
    <div 
      onClick={handleClick}
      className="bg-gradient-to-br from-dark-card to-dark-surface border border-dark-border rounded-3xl overflow-hidden shadow-xl transition-all duration-300 hover:shadow-2xl hover:shadow-accent-blue/20 hover:-translate-y-1 cursor-pointer group"
    >
      <div className="w-full aspect-[16/9] bg-gradient-to-br from-dark-border via-dark-card to-dark-surface flex items-center justify-center border-b border-dark-border relative overflow-hidden">
        {game.mainImage || game.featuredImage ? (
          <img 
            src={game.mainImage || game.featuredImage} 
            alt={game.title}
            className="w-full h-full object-cover"
          />
        ) : (
          <div className="w-full h-full bg-gradient-to-br from-dark-border via-dark-card to-dark-surface flex items-center justify-center">
            <div className="font-sans text-xs text-white/40 font-normal">Game Image</div>
          </div>
        )}
      </div>
      <div className="p-6 flex flex-col gap-4">
        <div>
          <h3 className="font-semibold text-xl text-white mb-1.5">{game.title}</h3>
          <p className="font-normal text-sm text-white/60">{game.developer}</p>
        </div>
        {!hidePrice && (
          <div className="mt-1 pt-3 border-t border-dark-border">
            <GamePrice game={game} isOwned={isOwned} />
          </div>
        )}
      </div>
    </div>
  );
}

export default GameCard;
